module.exports = __webpack_public_path__ + "static/img/10.21ee5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruselFuturo/10.jpg
// module id = CmrU
// module chunks = 5